import React, {useEffect} from 'react';
import $ from "../../utils/datatables";
import {Link} from "react-router-dom";
import moment from "moment";
import { toast } from 'react-toastify';
import {GET_PRODUCTS_URL} from "../../api";

const Product = (props) => {

    const token = localStorage.getItem('jwtToken');

    useEffect(() => {
        let table = $('#product_table').DataTable({
            responsive: true,
            language: {
                searchPlaceholder: 'Search',
                sSearch: '',
                lengthMenu: '_MENU_ items/page',
                processing: '<div class="spinner-border"></div><p class="mg-t-10 tx-12">Loading products</p>'
            },
            searching: true,
            lengthMenu: [[10], [10]],
            ordering: false,
            info: true,
            bFilter: false,
            processing: true,
            pageLength: 10,
            serverSide: true,
            ajax: function(data, callback) {
                $.ajax(`${GET_PRODUCTS_URL}`, {
                    type: 'GET',
                    headers: {
                        Authorization: token
                    },
                    success: function(res) {
                        const rawList = Array.isArray(res) ? res : (res?.results ?? res?.data ?? []);
                        const result = rawList.map((item) => ({ raw: item }));

                        callback({
                            recordsTotal: res?.count ?? result.length,
                            recordsFiltered: res?.count ?? result.length,
                            data: result
                        });
                    },
                    error: function(err) {
                        toast.error(err.statusText || 'Failed to load products', {position: "top-right", autoClose: 5000});
                        callback({ recordsTotal: 0, recordsFiltered: 0, data: [] });
                    }
                });
            },
            columns: [
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" },
                { data: "raw" }
            ],
            columnDefs: [
                {
                    render: function(data) {
                        const crop = data?.crop;
                        return (crop && typeof crop === 'object' ? (crop.name ?? crop.id) : data?.crop) ?? '—';
                    },
                    targets: 0
                },
                {
                    render: function(data) {
                        const member = data?.member;
                        if (!member) return '—';
                        if (typeof member === 'object') {
                            const name = [member.first_name, member.last_name].filter(Boolean).join(' ');
                            return name || member.username || member.email || member.id || '—';
                        }
                        return `#${member}`;
                    },
                    targets: 1
                },
                {
                    render: function(data) {
                        const qty = data?.standard_quantity ?? data?.quantity;
                        return qty != null ? Number(qty).toLocaleString() : '—';
                    },
                    targets: 2
                },
                {
                    render: function(data) {
                        return (data?.units) ?? '—';
                    },
                    targets: 3
                },
                {
                    render: function(data) {
                        return data?.date_created ? moment(data.date_created).format("Do MMM, YYYY") : '—';
                    },
                    targets: 4
                },
                {
                    render: function(data) {
                        return `<a href="#" class="nav-link view_product"><i class="fa fa-eye"></i> View product</a>`;
                    },
                    targets: 5
                }
            ]
        });

        table.on('click', '.view_product', function(e) {
            e.preventDefault();
            let rowData = table.row($(this).closest('tr')).data();
            if (rowData && rowData.raw && rowData.raw.id) {
                props.history.push(`/product/${rowData.raw.id}`);
            }
            return false;
        });
    }, [props.history, token]);

    const reloadTable = () => {
        if ($.fn.DataTable.isDataTable('#product_table')) {
            $('#product_table').DataTable().ajax.reload(null, false);
        }
    };

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Products</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-0 tx-spacing--1">Products</h4>
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="card">
                            <div className="card-header d-flex align-items-center justify-content-between">
                                <h6 className="mg-b-0">Products</h6>
                                <div className="d-flex tx-18">
                                    <Link to="#" onClick={reloadTable} className="link-03 lh-0"><i className="icon ion-md-refresh"></i></Link>
                                </div>
                            </div>
                            <div className="card-body table-responsive">
                                <table id="product_table" className="table table-hover" style={{width: "100%"}}>
                                    <thead>
                                        <tr>
                                            <th className="wd-15p">Crop</th>
                                            <th className="wd-18p">Member</th>
                                            <th className="wd-10p">Quantity</th>
                                            <th className="wd-8p">Units</th>
                                            <th className="wd-12p">Date Created</th>
                                            <th className="wd-12p">Action</th>
                                        </tr>
                                    </thead>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Product;
